import { render, staticRenderFns } from "./SSearch.vue?vue&type=template&id=5edc7ab8&scoped=true"
import script from "./sSearch.ts?vue&type=script&lang=ts&external"
export * from "./sSearch.ts?vue&type=script&lang=ts&external"
import style0 from "./SSearch.vue?vue&type=style&index=0&id=5edc7ab8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc7ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edc7ab8')) {
      api.createRecord('5edc7ab8', component.options)
    } else {
      api.reload('5edc7ab8', component.options)
    }
    module.hot.accept("./SSearch.vue?vue&type=template&id=5edc7ab8&scoped=true", function () {
      api.rerender('5edc7ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-search/SSearch.vue"
export default component.exports